export default {
    "很抱歉，您输入的网址在我们的网站上无法正常显示":"很抱歉，您输入的网址在我们的网站上无法正常显示",
    "请确认网址是否正确":"请确认网址是否正确",
    "该展会暂时还未对外开放":"该展会暂时还未对外开放",
    "请转到智奥会展(深圳)-主场服务平台，手动选择展会":"请转到智奥会展(深圳)-主场服务平台，手动选择展会",
}


// WEBPACK FOOTER //
// ./src/i18n/zh-cn/notFound.js